import { useMutation, useQuery } from '@tanstack/react-query';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useDebouncedState } from '@mantine/hooks';
import { toast } from 'react-toastify';
import { RECORDS_PER_PAGE } from '../../config';
import { useState } from 'react';
import { buildAxiosInstance } from '../axiosInstance';
import { LogoutCheck } from '../utils';
import { useMsal } from '@azure/msal-react';

export const useRoleList = () => {

	let dispatch = useDispatch();
	const { instance } = useMsal();
	return useQuery({
		queryKey: ['get_role'],
		retry: false,
		queryFn: async () => {
			try {

				const TOAST_ID = 'get_role'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.get(`roles`)
				return responseData

			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw new Error(`${error.response.data.message}`);
			}
		},
	});

};

export const useAddUser = () => {
	const dispatch = useDispatch();
	const { instance } = useMsal();

	return useMutation({
		mutationFn: async (body) => {
			try {

				const TOAST_ID = 'add_user'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.post(`/add_user`, JSON.stringify(body));
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw new Error(`${error.response.data.message}`);
			}
		},
	});
};

//update_user
export const useUpdateUser = () => {
	const dispatch = useDispatch();
	const { instance } = useMsal();

	return useMutation({
		mutationFn: async (body) => {
			try {

				const TOAST_ID = 'update_user'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.put(`/update_user`, JSON.stringify(body));
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw new Error(`${error.response.data.message}`);
			}
		},
	});
};

const fetchUserList = async (pageParam, Args, dispatch, signal,instance) => {
	try {

		const TOAST_ID = 'user_list'
		const axiosInstance = buildAxiosInstance(TOAST_ID)
		let config = {
			params:{
				search:Args.search,
				page:pageParam,
				limit:localStorage.getItem("page_count"),
				sort:Args.sort
			},
			signal: signal,
		};
		const responseData = await axiosInstance.get(`user_list`,config)
		return responseData

	} catch (error) {
		LogoutCheck(error, dispatch,instance)
		throw new Error(`${error.response.data.message}`);
	}
};

export const useUsersList = () => {
	let dispatch = useDispatch();
	const { instance } = useMsal();
	const [Args, setArgs] = useDebouncedState(
		{
			search: '',
			sort: '',
		},
		2000
	);
	const hook = useInfiniteQuery({
		queryKey: ['userlist', Args],
		queryFn: async ({ pageParam = 1 }) =>
			fetchUserList(pageParam, Args, dispatch,instance),
		getNextPageParam: (lastPage, allPages) => {
			if (allPages.length === 0) {
				return 1;
			} else if (allPages[allPages.length - 1].length === 0) {
				return allPages.length;
			} else {
				return allPages.length + 1;
			}
		},
	});

	return {
		hook: hook,
		Args: Args,
		setArgs: setArgs,
	};
};

export const useUserListPagewise = (pageNo) => {
	let dispatch = useDispatch();
	const { instance } = useMsal();
	const [Args, setArgs] = useState({
		search: '',
		sort: '',
		page: pageNo,
	});
	const hook = useQuery({
		queryKey: ['userlist', Args],
		queryFn: async ({ signal }) =>
			fetchUserList(Args.page, Args, dispatch, signal,instance),
		retry: false,
	});
	return {
		hook: hook,
		Args: Args,
		setArgs: setArgs,
	};
};

export const useGetEditUser = (id) => {
	let dispatch = useDispatch();
	const { instance } = useMsal();
	return useQuery({
		queryKey: ['get_user_by_id', id],
		retry: false,
		queryFn: async () => {
			try {

				const TOAST_ID = 'get_user_by_id'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.get(`get_user_by_id?id=${id}`)
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw new Error(`${error.response.data.message}`);
			}
		},
	});
};

export const useDeleteUser = () => {
	let dispatch = useDispatch();
	const { instance } = useMsal();
	return useMutation({
		//queryKey: ['get_user_by_id',id],
		retry: false,
		mutationFn: async (id) => {
			try {
				const TOAST_ID = 'delete_user'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				let config = {
					data: JSON.stringify({ id }),
				};
				const responseData = await axiosInstance.delete(`delete_user`,config)
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw new Error(`${error.response.data.message}`);
			}
		},
	});
};
